export default __webpack_public_path__ + "assets/audio/ssml/voicery-style.a51dde7c6fcf39c98c2075a741da2410.mp3";